import React from 'react';

const HtmlIframe  = () => {
  return (
    <iframe
      src="/Fr_index.html"
      title="My Static Page"
      width="100%"
      height="1000px"
      style={{ border: 'none' }}
    />
  );
};

export default HtmlIframe ;
